<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal title="主体明细记录" :width="1200" :open="true" :confirmLoading="state.loading" :maskClosable="false"
        @ok="onFormSubmit" @cancel="cancel" :footer="null">
        <a-card :bordered="false">
            <div class="table-page-search-wrapper">
                <a-form>
                    <a-row :gutter="48">
                        <a-col :md="6" :sm="24">
                            <a-form-item label="主体名称">
                                <a-input v-model:value="queryParam.full_name" placeholder="主体名称"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="状态" name="status">
                                <a-select allow-clear mode="multiple" v-model:value="queryParam.status"
                                    placeholder="请选择">
                                    <a-select-option :value="0">待处理</a-select-option>
                                    <a-select-option :value="1">处理中</a-select-option>
                                    <a-select-option :value="2">成功</a-select-option>
                                    <a-select-option :value="3">失败</a-select-option>
                                    <a-select-option :value="4">跳过</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <span class="table-page-search-submitButtons">
                                <a-button type="primary" @click="loadData">查询</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination"
                @change="onChange" rowKey="id">
                <template #bodyCell="{ column, record, index, text }">
                    <template v-if="column.dataIndex === 'status'">
                        <a-tag color="blue" v-if="record.status == 0">待处理</a-tag>
                        <a-tag color="orange" v-else-if="record.status == 1">处理中</a-tag>
                        <a-tag color="green" v-else-if="record.status == 2">成功</a-tag>
                        <a-tag color="red" v-else-if="record.status == 3">失败</a-tag>
                        <a-tag color="cyan" v-else-if="record.status == 4">跳过</a-tag>
                    </template>
                    <template v-else-if="column.dataIndex === 'operate'">

                    </template>
                </template>
            </a-table>
        </a-card>
    </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed, handleError } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { PaginationProps } from 'ant-design-vue'
import BetweenTimePick from '@/components/base/BetweenTimePick.vue'
const emit = defineEmits(['ok', 'cancel'])
const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})
const columns = [
    {
        title: '主体名称',
        dataIndex: 'full_name',
        width: 350
    },
    {
        title: '状态',
        dataIndex: 'status',
        width: 100
    },
    {
        title: '备注',
        dataIndex: 'remark',
        width: 200
    },
    {
        title: '更新时间',
        dataIndex: 'updated_at',
        width: 200
    },
    {
        title: '操作',
        dataIndex: 'operate',
        width: 200
    }
]
interface state {
    loading: boolean
    detailData: object
}
const state = reactive<state>({
    loading: false,
    detailData: {},
})
let queryParam = reactive<any>({
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '50', '100', '200', '1000', '2000'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})
onMounted(() => {
    loadData()
})
const loadData = () => {
    state.loading = true
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/robotsbatch/detail',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize, batch_id: props.detailData.id }, queryParam)
    }
    baseService(requestParam).then((res) => {
        state.loading = false
        pagination.total = res.data.total_records
        dataSource.value = res.data.list.map((item) => ({ ...item, isDetail: false }))
    })
}
const onChange = (val) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    loadData()
}
const onFormSubmit = () => {
    emit('cancel')
}
const cancel = () => {
    emit('cancel')
}
</script>
<style lang="less" scoped></style>
